import React, { Fragment, } from 'react';
import { Button, } from 'reactstrap';
import { orderBy, get, pick, omit, uniq, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { useCounter, useToggle, } from 'react-use';
import { Link } from 'react-router-dom';
import { format as formatDate } from 'date-fns';
import classnames from 'classnames';

import firebase from '../../firebase';
import { idWithTenant, } from '../../shared/util';
import { fieldDisplayValue, } from '../../shared/util';
import { statuses, adminFields, } from '../../shared/models/inventory';
import { isMobile, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentsSubscription from '../hooks/useDocumentsSubscription';
import useQueryParams from '../hooks/useQueryParams';
import AdminPage from '../hocs/AdminPage';
import CombiningModal from '../modals/CombiningModal';
import ModelFormModal from '../modals/ModelFormModal';
import QuerySelector from '../QuerySelector';
import AddButton from '../AddButton';
import ModalButton from '../ModalButton';
import EditButton from '../EditButton';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const locationsRef = db.collection('locations');

export default AdminPage(function AdminCombinings (props) {
  const locations = useCollectionSubscription(locationsRef.orderBy('sortKey'));
  const tenants = useCollectionSubscription(tenantsRef.orderBy('createdAt'));
  const tenantOptions = tenants.map(_ => ({ label: `[${_.id}] ${_.name}`, value: _.id }));
  const reallocateFields = () => ({
    tenantId: {
      type: 'select',
      label: 'テナント',
      options: tenantOptions,
      validations: { required: _ => _ != null, },
    },
  });
  const onSubmitReallocate = async ({ tenantId }, { onClickClose }) => {
    await tenantsRef.doc(tenantId).update({ shouldUpdateStatusOfShippingRequests: true });
    const next = new Date(Math.ceil(new Date().getTime() / (5 * 60 * 1000)) * 5 * 60 * 1000);
    toast.success(`${formatDate(next, 'HH:mm')}に再引当計算されます`);
    onClickClose();
  };

  return (
    <div className="admin-combinings container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>セット処理</h4>
        </div>
        <div className="d-flex justify-content-start align-items-end mb-3 gap-1">
          <ModalButton label="ピッキング" Modal={CombiningModal} modalProps={{ locations, }} />
          <ModalButton label="数量入力ピッキング" Modal={CombiningModal} modalProps={{ locations, enablesQuantity: true, }} />
          <ModalButton color="warning" Modal={ModelFormModal} modalProps={{ title: '再引当', fields: reallocateFields, onSubmit: onSubmitReallocate, submitLabel: '再引当', }}>
            再引当
          </ModalButton>
        </div>
      </div>
    </div>
  );
});
